import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reducers";
import {
  FilterItem,
  FilterItemTitle,
  FilterItemArrow,
  FilterItemData,
} from "./styles";
import FilterArrow from "../../assets/filter_arrow.svg";
import FilterArrowDark from "../../assets/filter_arrow_dark.svg";

interface Props {
  title: string;
  data?: string | null;
}

const Filter = ({ title, data }: Props) => {
  const filterStore = useSelector((state: RootState) => state.filter);
  const dispatch = useDispatch();
  const selected = title === filterStore.selectedFilter;

  return (
    <FilterItem
      selected={selected}
      onClick={() => {
        dispatch({
          type: "SET_SELECTED_FILTER",
          payload: title !== filterStore.selectedFilter ? title : "",
        });
      }}
    >
      <FilterItemTitle>{title}</FilterItemTitle>
      <FilterItemData>
        <b>{data}</b>
        <FilterItemArrow selected={selected}>
          <img
            src={selected ? FilterArrow : FilterArrowDark}
            alt="bookmaker selector arrow"
          />
        </FilterItemArrow>
      </FilterItemData>
    </FilterItem>
  );
};

export default Filter;
